import React from 'react';
import { Link } from 'react-router';
import AppRoutes from '../../routes/routes';
import PostHogService from '../../services/posthog';
import PostHogEvents from '../../constants/posthog-events';
import UserMenu from '../header/user-menu';
import MarketingSearchForm from '../homepage/marketing-search-form';
import AuthMixin from '../../mixins/authenticationMixin';
import MarketingDrawer from './marketing-drawer';

class MarketingNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            drawerOpen: false,
            dropdownOpen: false
        };
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.closeDropdown = this.closeDropdown.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
            this.setState({ dropdownOpen: false });
        }
    }

    toggleDrawer() {
        this.setState(prevState => ({ drawerOpen: !prevState.drawerOpen }));
    }

    toggleDropdown() {
        this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }));
    }

    closeDropdown() {
        this.setState({ dropdownOpen: false });
    }

    render() {
        const trackNav = (label) => {
            PostHogService.capture(PostHogEvents.NAVIGATION_CLICKED, { label });
        };

        const isHomePage = typeof window !== 'undefined' && window.location.pathname === '/';

        return (
            <React.Fragment>
                <nav>
                    <Link to="/" className="nav-brand">
                        {/* <div className="nav-mark" style={{ background: 'transparent', boxShadow: 'none' }}> */}
                        {/* mobile logo */}
                        <img className="mobile-logo" src={require('../../../images/brain-logo-blue.svg')} style={{ width: '40px', height: 'auto' }} alt="Neurochecklists Logo" />
                        {/* desktop logo */}
                        <img className="desktop-logo" src={require('../../../images/logo.svg')} style={{ width: '100%', height: '100%' }} alt="Neurochecklists Logo" />

                        {/* </div> */}
                        {/* <div className="nav-brand-text">
                        <div className="nav-brand-name">Neurochecklists</div>
                        <div className="nav-brand-sub" style={{ textTransform: 'lowercase' }}>your gateway to neurology</div>
                    </div> */}
                    </Link>

                    <div className="desktop-nav-group" style={{ display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center' }}>
                        {this.props.userLoggedIn && !isHomePage ? (
                            <div style={{ flex: 1, minWidth: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 30px', gap: '24px' }}>
                                {<MarketingSearchForm compact={true} {...this.props} searchMode="database" />}
                            </div>
                        ) : (
                            <ul className="nav-links">
                                <li><Link to={AppRoutes.explore} onClick={() => trackNav('Explore')}>Explore Dataset</Link></li>
                                <li><Link to={AppRoutes.axon} onClick={() => trackNav('Axon')}>Axon</Link></li>
                                <li><Link to={AppRoutes.about} onClick={() => trackNav('About')}>About</Link></li>
                                <li><Link to={AppRoutes.pricing} onClick={() => trackNav('Pricing')}>Pricing</Link></li>
                                <li className={`nav-dropdown ${this.state.dropdownOpen ? 'open' : ''}`} ref={node => this.dropdownRef = node}>
                                    <button
                                        className="nav-dropdown-trigger"
                                        aria-haspopup="true"
                                        aria-expanded={this.state.dropdownOpen}
                                        onClick={this.toggleDropdown}
                                        type="button"
                                    >
                                        Resources
                                        <svg className="chevron-down" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="6 9 12 15 18 9"></polyline>
                                        </svg>
                                    </button>
                                    <ul className="nav-dropdown-menu">
                                        <li>
                                            <a href={AppRoutes.news} target="_blank" className="nav-dropdown-item" onClick={() => { trackNav('The Neurology Lounge Podcast'); this.closeDropdown(); }} rel="noopener noreferrer">
                                                The Neurology Lounge Podcast
                                            </a>
                                        </li>                                        
                                        <li>
                                            <a href={AppRoutes.substack} target="_blank" className="nav-dropdown-item" onClick={() => { trackNav('Substack'); this.closeDropdown(); }} rel="noopener noreferrer">
                                                Substack
                                            </a>
                                        </li>
                                        <li>
                                            <Link to={AppRoutes.surfing_the_brain_int} target="_blank" className="nav-dropdown-item" onClick={() => { trackNav('Surfing the Brain'); this.closeDropdown(); }}>
                                                Surfing the Brain
                                            </Link>
                                        </li>
                                        <li>
                                            <a href={AppRoutes.book} target="_blank" className="nav-dropdown-item" onClick={() => { trackNav('700 Essential Neurology Checklists'); this.closeDropdown(); }} rel="noopener noreferrer">
                                                700 Essential Neurology Checklists
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        )}

                        <div className="nav-cta">
                            {this.props.userLoggedIn ? (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <UserMenu loggedIn={true} user={this.props.user} marketingMode={true} {...this.props} />
                                    <button className="hamburger-btn" onClick={this.toggleDrawer} style={{ marginLeft: '12px' }} aria-label="Open menu">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
                                    </button>
                                </div>
                            ) : (
                                <React.Fragment>
                                    <button className="btn btn-ghost-nav" onClick={() => window.location.href = '/home?modal=login'}>Log in</button>
                                    <button className="btn btn-primary-sm" onClick={() => window.location.href = '/home?modal=register'}>Get started</button>
                                </React.Fragment>
                            )}
                        </div>
                    </div>

                    <div className="mobile-nav-group" style={{ display: 'flex', flex: 1, minWidth: 0, justifyContent: 'flex-end', alignItems: 'center', gap: '12px', marginLeft: '12px' }}>
                        {this.props.userLoggedIn && !isHomePage && (
                            <div className="mobile-search-nav" style={{ flex: 1, minWidth: 0 }}>
                                <MarketingSearchForm compact={true} {...this.props} searchMode="database" />
                            </div>
                        )}
                        <button className="hamburger-btn" onClick={this.toggleDrawer} aria-label="Open menu">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
                        </button>
                    </div>

                </nav>

                <MarketingDrawer
                    isOpen={this.state.drawerOpen}
                    onClose={this.toggleDrawer}
                    userLoggedIn={this.props.userLoggedIn}
                    user={this.props.user}
                    trackNav={trackNav}
                />
            </React.Fragment>
        );
    }
}

export default AuthMixin(MarketingNav);
